// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Ben Richardson <hi@ben.gy>
import type { ViewContext } from '../viewContext';
import { escapeHtml } from '../utils/format';
import { viewHead, wireNameRows } from './shared';
import { nameKeyOf } from '../components/drilldown';

export function renderInsights(root: HTMLElement, ctx: ViewContext): void {
  const insights = ctx.data.agg.insights;

  root.innerHTML = `
    ${viewHead(
      'Insights',
      'Findings picked out automatically from the data — the longest reigns, the fastest climbers, the brightest flashes in the pan. Click any name to open its full profile.',
    )}
    <div class="insight-grid">
      ${insights
        .map(
          (ins) => `<div class="insight ${escapeHtml(ins.severity)}">
            <h3>${escapeHtml(ins.title)}</h3>
            <p>${escapeHtml(ins.body)}</p>
            ${
              ins.links.length
                ? `<div class="insight-links">${ins.links
                    .filter((l, i, a) => a.indexOf(l) === i)
                    .map((l) => `<span class="chip" data-key="${escapeHtml(nameKeyOf(l))}" role="button" tabindex="0">${escapeHtml(l)}</span>`)
                    .join('')}</div>`
                : ''
            }
          </div>`,
        )
        .join('')}
    </div>
  `;

  wireNameRows(root, ctx.openName);
}
